import React from 'react';

export interface MilestoneData {
  id: string;
  label: string;
  headline: string;
  body: string;
  year: string;
  icon: string;
}

interface MilestoneCardProps {
  milestone: MilestoneData;
}

const MilestoneCard: React.FC<MilestoneCardProps> = ({ milestone }) => {
  return (
    <div
      className="milestone-card masonry-item span-2 reveal"
      style={{ borderRadius: '2px', padding: '0' }}
    >
      <div
        className="flex flex-col md:flex-row items-stretch"
        style={{ minHeight: '180px' }}
      >
        {/* Left accent bar */}
        <div
          className="flex-shrink-0 flex items-center justify-center"
          style={{
            width: '80px',
            background: 'rgba(184,160,74,0.15)',
            borderRight: '1px solid rgba(184,160,74,0.2)',
            padding: '24px 0',
          }}
        >
          <span style={{ fontSize: '2.2rem' }}>{milestone.icon}</span>
        </div>

        {/* Content */}
        <div className="flex-1 p-6 md:p-8 relative z-10">
          <div className="flex flex-wrap items-center gap-3 mb-3">
            <span
              className="section-label"
              style={{ color: 'var(--color-brass)', letterSpacing: '0.15em' }}
            >
              {milestone.label}
            </span>
            <span
              className="font-body text-xs"
              style={{ color: 'rgba(245,240,232,0.4)' }}
            >
              · {milestone.year}
            </span>
          </div>
          <h3
            className="font-display font-bold text-xl md:text-2xl leading-tight mb-2"
            style={{ color: 'var(--color-parchment)' }}
          >
            {milestone.headline}
          </h3>
          <p
            className="font-body text-sm leading-relaxed max-w-xl"
            style={{ color: 'rgba(245,240,232,0.65)' }}
          >
            {milestone.body}
          </p>
        </div>

        {/* Right year */}
        <div
          className="hidden md:flex flex-shrink-0 items-center justify-center px-8"
          style={{ borderLeft: '1px solid rgba(245,240,232,0.08)' }}
        >
          <span
            className="font-display font-black"
            style={{
              fontSize: '4rem',
              color: 'rgba(245,240,232,0.06)',
              lineHeight: 1,
              userSelect: 'none',
            }}
          >
            {milestone.year}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MilestoneCard;